<template>
    <v-card outlined style="overflow: hidden">
        <v-tabs v-model="view">
            <v-tab>
                실시간 시청자 <span class="ml-4"> ({{ count }}) </span>
            </v-tab>
            <v-tab> 시청 기록 </v-tab>
        </v-tabs>
        <v-divider />
        <v-tabs-items v-model="view">
            <v-tab-item>
                <meta-watcher />
            </v-tab-item>
            <v-tab-item>
                <meta-watches :isActive="view == 1" />
            </v-tab-item>
        </v-tabs-items>
    </v-card>
</template>

<script>
import { mapState } from "vuex";

import MetaWatcher from "./meta/meta-watcher.vue";
import MetaWatches from "./meta/meta-watches.vue";

export default {
    components: {
        MetaWatcher,
        MetaWatches,
    },
    data: () => ({
        view: "watcher",
    }),
    computed: {
        ...mapState("lecture/chat", ["count"]),
    },
};
</script>

<style>
</style>